module.exports = __webpack_public_path__ + "img/KC.4684ac5a.png";